app.controller('shellCtrl', [
    '$scope', 'navService', function ($scope, navService) {
    	$scope.navService = navService;
	}
]);